import React, { useEffect } from 'react';
import { Switch, Route, useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import analytics from 'lib/analytics';
import { pathnames } from 'lib/routes';
import ApplicationProvider from 'lib/application-provider';
import BeneficialOwnerProvider from 'lib/beneficial-owner-provider';
import { useAuth } from 'lib/auth-provider';
import Wrapper from 'components/layout/Wrapper';
import Container from 'components/layout/Container';
import Header from 'components/header';
import Footer from 'components/footer';
import { Slide } from 'components/transitions';
import BeneficialOwnerMultiForm from 'pages/BeneficialOwnerMultiForm';
import MultiForm from 'pages/MultiForm';
import Start from 'pages/Start';
import VerifyEmail from 'pages/VerifyEmail';
import ThankYou from 'pages/ThankYou';

const Main = styled.main`
  display: flex;
  flex: 1 0 auto;
`

const App = () => {
  const { isAuthLoading, isAuthenticated, authType } = useAuth();
  const location = useLocation();
  const history = useHistory();

  // track page view when location is updated
  useEffect(() => {
    analytics.pageView();
  }, [location]);

  useEffect(() => {
    analytics.track("Start Loaded");
  }, [])

  // force redirect to first step
  useEffect(() => {
    if (isAuthenticated) {
      if (authType === "application_token") {
        history.replace(pathnames.account_type)
      } else if (authType === "beneficial_owner_token") {
        history.replace(pathnames.beneficial_owner)
      }
    }
  }, [isAuthenticated, history, authType])

  return (
      <Wrapper color="pageBackground">
        <Header />
        <Main>
          <Container>
            <Slide>
              <Switch location={location}>
                <Route exact path={pathnames.root}>
                {
                  <Start />
                }
                </Route>
                <Route exact path={pathnames.verify_email}>
                {
                  <VerifyEmail />
                }
                </Route>
                <Route exact path={pathnames.thank_you}>
                  <ThankYou />
                </Route>
                <Route path={pathnames.beneficial_owner}>
                  {/* Non-standard route, completed by each beneficial owner separately from main application (if applicable) */}
                  {
                    !isAuthLoading && isAuthenticated ?
                    <BeneficialOwnerProvider>
                      <BeneficialOwnerMultiForm />
                    </BeneficialOwnerProvider>
                    :
                    null // TODO: not authenticated state
                  }
                </Route>
                <Route>
                  {
                    !isAuthLoading && isAuthenticated ?
                    <ApplicationProvider>
                      <MultiForm />
                    </ApplicationProvider>
                    :
                    null // TODO: not authenticated state
                  }
                </Route>
              </Switch>
            </Slide>
          </Container>
        </Main>
        <Footer />
      </Wrapper>
  );
}

export default App;
